const hasHover = () => window.matchMedia('(hover: hover)').matches

export default hasHover
